import { NgModule } from '@angular/core';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { EventBusService } from './services/event-bus.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

@NgModule({
	imports: [
	],
	providers: [
		EventBusService,
	],
	declarations: [
	],
	exports: [
	]
})
export class EventsModule {
	constructor() { }
}

angular.module('auroraApp') //
	.service('eventBusService',
		downgradeInjectable(EventBusService)
	) //
;